module.exports = JBrowseExports["mobx-react"];